<template>
  <div class="padding7 el-card">
    <el-form :model="voucherQueryModel" label-width="120px" label-position="left">
      <div>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="品牌" label-width="80px">
              <el-select
                v-model="voucherQueryModel.brandId"
                placeholder="选择品牌"
                size="mini"
                class="width100"
                @change="brandChange"
              >
                <el-option
                  v-for="item in brandList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-show="brandSel">
            <el-form-item label="门店" label-width="50px">
              <el-select
                v-model="voucherQueryModel.store"
                placeholder="选择门店"
                size="mini"
                class="width100"
                @change="storeChange"
              >
                <el-option
                  v-for="item in storesList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="制单日期" label-width="80px">
              <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                size="mini"
                style="width:100%"
                @change="timeChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="top7">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-download"
              class="pull-right"
              @click="voucherCreateShow"
              :disabled="!isSearchVal"
            >同步单据</el-button>
            <el-button
              type
              size="mini"
              icon="el-icon-search"
              class="pull-right right-20"
              @click="search"
              :disabled="!storeSel"
            >查询</el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <el-table :data="tableData" size="mini" style="width: 100%;" border>
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column label="日期">
        <template slot-scope="scope">{{timeFormat(scope.row)}}</template>
      </el-table-column>
      <el-table-column prop="create_shop_name" label="门店"></el-table-column>
      <el-table-column prop="create_shop_id" label="门店编号"></el-table-column>
      <el-table-column prop="totalOrig_Amount" label="营业额(元)"></el-table-column>
      <el-table-column prop="totalAmount" label="营业收入(元)"></el-table-column>
    </el-table>
    <pagerBar
      ref="refPagerBar"
      :apiURL="VoucherDataApi"
      :GetData="getTableData"
      :queryParam="queryParam"
      :isInit="false"
      :errorFunc="errorHandler"
    ></pagerBar>
  </div>
</template>

<script>
import moment from "moment";
import config from "@/common/config.js";
import pagerBar from "@/views/pager/pagerBar";
import AjaxHelper from "@/common/js/AjaxHelper";
export default {
  data() {
    return {
      isSearchVal: false,
      isVoucherCreate: false,
      queryParam: {},
      brandSel: true,
      storeSel: false,
      CurrnetMID: 0,
      VoucherCreateApi: config.BASE_Middle_API + "OrderCreate",
      VoucherDataApi: config.BASE_Middle_API + "OrderCreate/GetPosData", //获取源数据接口 需提供
      Visible: false,
      optionsList: [],
      moduleList: [],
      brandList: [],
      brands: [],
      storesList: [],
      stores: [],
      tableData: [],
      accountList: [],
      time: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      voucherQueryModel: {
        startTime: moment().format("YYYY-MM-DD"),
        endTime: moment().format("YYYY-MM-DD"),
        brandId: "",
        store: ""
      }
    };
  },
  props: {
    openloading: {
      type: Function,
      required: true
    },
    closeloading: {
      type: Function,
      required: true
    },
    tabType: {
      type: String,
      required: true
    }
  },
  components: { pagerBar },
  mounted() {
    this.getModules();
  },
  methods: {
    timeFormat(row) {
      return moment(row.voucherDate).format("YYYY-MM-DD");
    },
    timeChange(val) {
      this.voucherQueryModel.startTime = moment(val[0]).format("YYYY-MM-DD");
      this.voucherQueryModel.endTime = moment(val[1]).format("YYYY-MM-DD");
    },
    errorHandler() {
      this.closeloading();
    },
    search() {
      this.openloading();
      let confirmData = Object.assign({}, this.voucherQueryModel);
      if (this.voucherQueryModel.store == "") {
        let storeCode = [];
        let storeIDs = [];
        this.storesList.map(x => {
          storeCode.push(x.storeCode);
          storeIDs.push(x.id);
        });
        confirmData.shopCode = storeCode.join(","); //门店编号
        confirmData.storeID = storeIDs.join(","); //门店ID
      } else {
        const storeID = this.voucherQueryModel.store;
        const storeItem = this.storesList.filter(x => x.id == storeID);
        confirmData.shopCode = storeItem[0].storeCode;
        confirmData.storeID = storeID;
      }

      this.queryParam = Object.assign({}, confirmData);
    },
    voucherCreateShow() {
      const _this = this;
      this.openloading();
      //凭证生成接口
      const confirmData = {
        brandID: _this.queryParam.brandId,
        storeCode: _this.queryParam.shopCode,
        storeID: _this.queryParam.storeID,
        startTime: _this.queryParam.startTime,
        endTime: _this.queryParam.endTime
      };
      AjaxHelper.post(_this.VoucherCreateApi + "/PosDataHandle", confirmData)
        .then(function(response) {
          if (response.result.isSuccess) {
            {
              _this.$notify({
                title: "提示",
                message: response.result.successMsg,
                type: "success",
                position: "bottom-right"
              });
            }
          } else {
            _this.$notify({
              title: "提示",
              message: response.result.errorMsg,
              type: "error",
              position: "bottom-right"
            });
          }
          _this.closeloading();
        })
        .catch(function(error) {
          _this.closeloading();
        });
    },
    voucherCreate() {
      if (this.voucherQueryModel.account == "") {
        _this.$message({
          type: "error",
          message: "请选择账套"
        });
        return false;
      }
    },
    getAccount() {},
    getTableData(d) {
      this.tableData = d;
      //查询无结果 不允许生成凭证
      if (d.length > 0) {
        this.isSearchVal = true;
      } else {
        this.isSearchVal = false;
      }
      this.closeloading();
    },
    storeChange() {
      this.storeSel = true;
    },
    brandChange(val) {
      this.brandSel = true;
      this.isSearchVal = false;
      this.storeSel = false;
      this.voucherQueryModel.store = "";
      this.storesList = this.stores.filter(x => x.brandID === val);
    },
    statusSearch(item) {
      this.storeSel = false;
      // this.brandSel = false;
      this.CurrnetMID = item.id;
      this.voucherQueryModel.brandId = "";
      this.voucherQueryModel.store = "";
      this.brandList = this.brands.filter(x => x.moduleID == item.id);
      this.isSearchVal = false;
    },
    getModules() {
      const _this = this;
      this.openloading();
      AjaxHelper.get(
        _this.VoucherCreateApi + "/GetModules?tabType=" + _this.tabType
      )
        .then(function(response) {
          if (response.success) {
            _this.moduleList = response.result.modules;
            if (_this.moduleList.length > 0) {
              const firstItem = _this.moduleList[0];
              _this.CurrnetMID = firstItem.id;
              _this.brands = response.result.brands;
              _this.stores = response.result.stores;
              _this.brands.forEach(x => {
                _this.moduleList.forEach(element => {
                  if (element.id == x.moduleID) {
                    _this.brandList.push(x);
                  }
                });
              });
            }
          }
          _this.closeloading();
        })
        .catch(function(error) {
          _this.closeloading();
        });
    },
    pickerOptions2() {},
    initData() {},

    handleClose(done) {
      this.isVoucherCreate = false;
      done();
    }
  }
};
</script>

<style scoped>
.minicard {
  height: auto !important;
  display: block;
  width: 200px;
  position: absolute;
  right: 0;
  z-index: 9989;
  top: 80px;
}
.minicard .el-button {
  width: 150px;
  margin: 5px 0;
}
.el-dialog__body {
  padding: 10px 15px !important;
}

dl.loglist p {
  font-weight: 600;
  margin: 20px 0 10px 0;
}
dl.loglist dd {
  padding: 15px 0;
  color: #999999;
  display: block;
}
dl,
dt,
dd {
  margin: 0;
  padding: 0;
}
.w25 {
  width: 25%;
  float: left;
}
.w75 {
  width: 75%;
  float: left;
}
.el-card {
  border: 0;
  height: calc(100vh - 225px);
  overflow-y: auto;
}
.padding7 {
  padding: 7px;
}
.top7 {
  padding: 7px 0 0 0;
}
</style>